import React, { useCallback, useRef } from "react";
import * as FlexmonsterReact from "react-flexmonster";

import { isFunction } from "@cayuse/shared-react.utils.type-checks";
import { produce } from "immer";

import styles from "./styles.css";
export const ReportingGrid = props => {
	const {
		reportRef,
		restore,
		dataerror,
		onReportUpload,
		...rest
	} = props;
	const inputFileRef = useRef();

	const customizeToolbar = useCallback(toolbar => {
		let tabs = toolbar.getTabs();

		toolbar.getTabs = function () {
			// remove the Connect, Chart, Options tab
			tabs = tabs.filter(tab => tab.id !== "fm-tab-connect" && tab.id !== "fm-tab-charts" && tab.id !== "fm-tab-options");

			// remove the Open Remote Report option
			const openTab = tabs.find(tab => tab.id === "fm-tab-open");
			openTab.menu.pop();

			// override the Open tab
			tabs.splice(0, 1, {
				id: "fm-tab-open",
				title: this.Labels.open,
				handler: () => inputFileRef.current?.click(),
				icon: this.icons.open,
			});

			// override the Restore tab
			tabs.splice(2, 0, {
				id: "fm-tab-restore-default",
				title: "Restore",
				rightGroup: true,
				handler: restore,
				icon: this.icons.open,
			});

			return tabs;
		};
	}, [ restore, inputFileRef ]);

	const uploadFile = useCallback(event => {
		const file = event.target.files[0];
		const reader = new FileReader();

		reader.onload = async e => {
			const text = e.target.result;
			try {
				// ignore dataSource field in the uploaded report
				const uploadedReport = JSON.parse(text);
				if (isFunction(onReportUpload)) {
					onReportUpload(uploadedReport.slice);
				}
				const { dataSource, ...rest } = uploadedReport;

				// update the report in the grid, which will also update the report
				// config in the parent component (they're listening for changes)
				const flexmonster = reportRef.current?.flexmonster;
				const newReport = produce(flexmonster?.getReport(), r => {
					const dataSource = r?.dataSource;

					return {
						...rest,
						dataSource
					};
				});
				// eslint-disable-next-line no-unused-expressions
				flexmonster?.setReport(newReport);
			}
			catch (e) {
				console.error(e);
				dataerror({
					error: "Saved Report has incorrect format."
				});
			}
			finally {
				inputFileRef.current.value = null;
			}
		};

		if(file) {
			reader.readAsText(file);
		}
	}, [ dataerror, inputFileRef, reportRef ]);

	return (
		<>
			<input type="file" ref={inputFileRef} className={styles.hidden} onChange={uploadFile}/>
			<FlexmonsterReact.Pivot
				toolbar
				ref={reportRef}
				beforetoolbarcreated={customizeToolbar}
				componentFolder="https://cdn.flexmonster.com/"
				width="100%"
				licenseKey="Z71U-XE08CH-0R6C1Z-54690G-0P3C3Z-2W4X3I-471J1N-0R3K"
				{...rest}
			/>
		</>
	);
};

export default ReportingGrid;
